import React from 'react';

import { BANK_DISCLOSURE_SHORT } from 'constants/disclosures';

interface BankDisclosureProps {
  className?: string;
}

/**
 * Renders the short bank partnership disclosure.
 *
 * Thera is a financial technology company, not a bank — banking services are
 * provided by OMB Bank, Member FDIC. This component surfaces the short
 * disclosure copy (see `BANK_DISCLOSURE_SHORT`) so it can be reused across the
 * app (dashboard, settings, etc.) without duplicating the text.
 */
const BankDisclosure: React.FC<BankDisclosureProps> = ({ className = '' }) => {
  // `whitespace-pre-line` preserves the newline in BANK_DISCLOSURE_SHORT so the
  // copy renders across two lines instead of collapsing the break into a space.
  return (
    <p className={`whitespace-pre-line text-xs font-light leading-relaxed text-neutral-400 ${className}`.trim()}>
      {BANK_DISCLOSURE_SHORT}
    </p>
  );
};

export default BankDisclosure;
